import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Radar } from 'lucide-react';
import api from '../../utils/axios';
import { AgregarVigilanciaDialog } from './AgregarVigilanciaDialog';

export const VigilarCuentaButton = ({ termino, testid = 'btn-vigilar-cuenta' }) => {
  const [puede, setPuede] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get('/vigilancia/permisos').then((r) => setPuede(!!r.data?.crear)).catch(() => setPuede(false));
  }, []);

  if (!puede) return null;
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} style={{ color: '#0f766e', borderColor: '#99f6e4' }} data-testid={testid}>
        <Radar size={16} className="mr-2" style={{ color: '#0f766e' }} />
        <span style={{ color: '#0f766e' }}>Vigilar</span>
      </Button>
      <AgregarVigilanciaDialog open={open} onOpenChange={setOpen} initialTermino={termino || ''} />
    </>
  );
};

export default VigilarCuentaButton;
